export default {
  MUST_LOGIN: 'MUST_LOGIN',
  LOGIN: {
    REQUEST: 'REQUEST_AUTH_LOGIN',
    RECEIVE: 'RECEIVE_AUTH_LOGIN',
    FAIL: 'FAIL_AUTH_LOGIN',
    DISMISS_ERROR: 'AUTH_LOGIN_DISMISS_ERROR'
  },
  LOGOUT: {
    REQUEST: 'REQUEST_AUTH_LOGOUT',
    RECEIVE: 'RECEIVE_AUTH_LOGOUT',
    FAIL: 'FAIL_AUTH_LOGOUT'
  },
  SIGNUP: {
    REQUEST: 'REQUEST_AUTH_SIGNUP',
    RECEIVE: 'RECEIVE_AUTH_SIGNUP',
    FAIL: 'FAIL_AUTH_SIGNUP',
    DISMISS_ERROR: 'DISMISS_ERROR_AUTH_SIGNUP'
  },
  FORGOT_PASSWORD: {
    REQUEST: 'REQUEST_FORGOT_PASSWORD',
    RECEIVE: 'RECEIVE_FORGOT_PASSWORD',
    FAIL: 'FAIL_FORGOT_PASSWORD'
  },
  RESET_PASSWORD: {
    REQUEST: 'REQUEST_RESET_PASSWORD',
    RECEIVE: 'RECEIVE_RESET_PASSWORD',
    FAIL: 'FAIL_RESET_PASSWORD',
    DISMISS_ERROR: 'DISMISS_ERROR_AUTH_RESET_PASSWORD'
  }
}
